<template>
    <div class="whole q-mt-xl">
        <div class="title">
            <h5>System Admin</h5>
        </div>
        <div class="form">
            <div class="q-gutter-md q-mb-lg q-ml-xl">
                <q-radio v-model="accountHandler" val="Organisation" label="Organisation"></q-radio>
                <q-radio v-model="accountHandler" val="User" label="User"></q-radio> <br>


            </div>
            <form action="">
                <div v-if="accountHandler == 'Organisation'">
                    <div class="input-field">

                        <input type="text" id="name" name="Name" v-model="organisation['name']" required />


                        <label class="label-1" for="name">Name</label>
                        <label class="label-2" v-html="error_name" ref="label-name" for="name"></label>
                        <label for="name" class="label-3"><font-awesome-icon v-if="is_name_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="name" class="label-3"><font-awesome-icon v-if="is_name_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>


                    </div>


                    <div class="input-field">

                        <input type="text" id="address" name="address" v-model="organisation['address']" required />


                        <label class="label-1" for="address">Address</label>
                        <label class="label-2" v-html="error_address" ref="label-email1" for="email1"></label>
                        <label for="GSTIN" class="label-3"><font-awesome-icon v-if="is_address_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="GSTIN" class="label-3"><font-awesome-icon v-if="is_address_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>



                    </div>
                    <div class="input-field">

                        <input type="text" id="GSTIN" v-model="organisation['gstin']" required />


                        <label class="label-1" for="GSTIN">GSTIN</label>
                        <label class="label-2" v-html="error_gstin" ref="label-email1" for="email1"></label>
                        <label for="GSTIN" class="label-3"><font-awesome-icon v-if="is_gstin_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="GSTIN" class="label-3"><font-awesome-icon v-if="is_gstin_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>



                    </div>
                    <div class="input-field">

                        <input type="text" id="email" v-model="organisation['email']" required />


                        <label class="label-1" for="email">Primary Email</label>
                        <label class="label-2" v-html="error_email" ref="label-email1" for="email"></label>
                        <label for="email" class="label-3"><font-awesome-icon v-if="is_email_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="email" class="label-3"><font-awesome-icon v-if="is_email_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>



                    </div>
                    <div class="input-field">

                        <input type="text" id="phone" v-model="organisation['phone']" required />


                        <label class="label-1" for="phone">Primary Phone</label>
                        <label class="label-2" v-html="error_phone" ref="label-email1" for="phone"></label>
                        <label for="phone" class="label-3"><font-awesome-icon v-if="is_phone_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="phone" class="label-3"><font-awesome-icon v-if="is_phone_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>



                    </div>
                    <div class="input-field">
                        <input type="text" id="password" name="password" v-model="organisation['password']" required />

                        <label class="label-1" for="password">Password</label>
                        <label class="label-2" v-html="error_password" ref="label-password" for="password"></label>
                        <label for="password" class="label-3"><font-awesome-icon v-if="is_password_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="password" class="label-3"><font-awesome-icon v-if="is_password_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>

                    </div>
                    <div class="input-field">
                        <input type="text" id="passwordconfrm" name="passwordconfrm" v-model="organisation['password1']"
                            required />

                        <label class="label-1" for="passwordconfrm">Confirm Password</label>
                        <label class="label-2" v-html="error_password_confirm" ref="label-password"
                            for="passwordconfrm"></label>
                        <label for="passwordconfrm" class="label-3"><font-awesome-icon v-if="is_passwordconfirm_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="passwordconfrm" class="label-3"><font-awesome-icon v-if="is_passwordconfirm_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>

                    </div>
                    <div class="password-caption q-mx-lg text-caption">
                        <p>* Password should be 6 to 15 characters which contain at least one numeric digit and a
                            special character</p>
                    </div>


                </div>
                <div v-if="accountHandler == 'User'">
                    <div class="row">
                        <div class="input-field col-3">

                            <q-btn-dropdown class="q-ml-xl" :label="orgRole" style="color: black;font-size:15px;">
                                <q-list>
                                    <q-item clickable v-for="item in ['Admin', 'View Only']" :key="item" v-close-popup
                                        @click="get_role(item)">
                                        <q-item-section>
                                            <q-item-label>{{ item }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                            </q-btn-dropdown>



                            <!-- <input type="text" id="name1" name="Name1" v-model="user['name']" required />


                        <label class="label-1" for="name1">Name</label>
                        <label class="label-2" v-html="error_name1" ref="label-name" for="name1"></label>
                        <label for="name1" class="label-3"><font-awesome-icon v-if="is_name1_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="name1" class="label-3"><font-awesome-icon v-if="is_name1_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label> -->





                        </div>

                        <div class="input-field col">
                            <q-btn-dropdown :label="orgID" style="color: black;font-size:15px;">
                                <q-list>
                                    <q-item clickable v-for="item in reponseData" :key="item" v-close-popup
                                        @click="get_org_id(item)">
                                        <q-item-section>
                                            <q-item-label>{{ item }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                            </q-btn-dropdown>
                        </div>
                    </div>
                    <div class="input-field">

                        <input type="text" id="email1" v-model="user['email']" required />


                        <label class="label-1" for="email1">Email</label>
                        <label class="label-2" v-html="error_email1" ref="label-email1" for="email1"></label>
                        <label for="email1" class="label-3"><font-awesome-icon v-if="is_email1_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="email1" class="label-3"><font-awesome-icon v-if="is_email1_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>



                    </div>
                    <div class="input-field">

                        <input type="text" id="phone1" v-model="user['phone']" required />


                        <label class="label-1" for="phone1">Phone</label>
                        <label class="label-2" v-html="error_phone1" ref="label-email1" for="phone1"></label>
                        <label for="phone1" class="label-3"><font-awesome-icon v-if="is_phone1_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="phone1" class="label-3"><font-awesome-icon v-if="is_phone1_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>



                    </div>


                    <!-- <div class="input-field">
                        <input type="text" id="company" name="Company" v-model="user['company']" required />

                        <label class="label-1" for="company">Organisation ID</label>
                        <label class="label-2" v-html="error_company" ref="label-company" for="company"></label>
                        <label for="company" class="label-3"><font-awesome-icon v-if="is_company_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="company" class="label-3"><font-awesome-icon v-if="is_company_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>

                    </div> -->

                    <div class="input-field">
                        <input type="text" id="password" name="password" v-model="user['password']" required />

                        <label class="label-1" for="password">Password</label>
                        <label class="label-2" v-html="error_password1" ref="label-password" for="password"></label>
                        <label for="password" class="label-3"><font-awesome-icon v-if="is_password1_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="password" class="label-3"><font-awesome-icon v-if="is_password1_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>

                    </div>
                    <div class="input-field">
                        <input type="text" id="password1" name="password1" v-model="user['password1']" required />

                        <label class="label-1" for="password1">Confirm Password</label>
                        <label class="label-2" v-html="error_password_confirm1" ref="label-password"
                            for="password1"></label>
                        <label for="password1" class="label-3"><font-awesome-icon v-if="is_passwordconfirm1_valid"
                                icon="fa-solid fa-circle-check" style="color:green" class="valid-icons" /></label>
                        <label for="password1" class="label-3"><font-awesome-icon v-if="is_passwordconfirm1_error"
                                icon="fa-solid fa-exclamation-circle" style="color:red" class="valid-icons" /></label>

                    </div>
                    <div class="password-caption q-mx-lg text-caption">
                        <p>* Password should be 6 to 15 characters which contain at least one numeric digit and a
                            special character</p>
                    </div>
                </div>




                <div class="login">
                    <!-- <q-btn @click="submit_request_access()" label="Submit"></q-btn> -->

                    <q-btn class="analysisbtn col-auto" unelevated rounded @click="submit()" label="Submit"></q-btn>
                </div>






            </form>
        </div>
    </div>
</template>
 
<script>
import awsconfig from "../../aws-exports";
import { Auth } from "aws-amplify";

Auth.configure(awsconfig);

export default {
    data() {
        return {
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            accountHandler: 'Organisation',
            reponseData: [],
            is_password1_valid: false,
            is_company_valid: false,
            is_name_valid: false,
            is_email_valid: false,
            is_email_error: false,
            is_password1_valid: false,
            is_company_error: false,
            is_name_error: false,
            is_passwordconfirm_valid: false,
            is_passwordconfirm1_valid: false,
            is_passwordconfirm_error: false,
            is_passwordconfirm1_error: false,

            is_password_valid: false,
            is_password_error: false,
            is_company1_valid: false,
            is_name1_valid: false,
            is_email1_valid: false,
            is_email1_error: false,
            is_password1_error: false,
            is_company1_error: false,
            is_name1_error: false,
            is_gstin_valid: false,
            is_gstin_error: false,
            is_address_valid: false,
            is_address_error: false,
            is_phone_valid: false,
            is_phone_error: false,
            is_phone1_valid: false,
            is_phone1_error: false,
            orgRole: 'Select Role',
            orgID: 'organisation ID',

            user: {
                "name": '',
                "email": '',
                "phone": '',
                "company": '',
                "password": '',
                "password1": '',

            },
            organisation: {
                "name": '',
                "address": '',
                "gstin": '',
                "email": '',
                "phone": '',
                "password": '',
                "password1": '',

            },

        }

    },
    mounted() {
        this.$q.loading.show({
            message: "Authenticating please wait..",
        });
        if (this.$cookies.isKey("login_authentication")) {
            let encryptedText = this.$cookies.get("login_authentication");
            const decryptedText = this.$CryptoJS.AES.decrypt(
                encryptedText,
                process.env.VUE_APP_ENCRYPTION_SECRET_KEY
            ).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/SystemAdmin");
                this.isAuthenticated = true;
                var productsURL1 = this.api_url + "/multiuser/get_org_list";
                this.$http
                    .post(productsURL1)
                    .then((response) => {
                        let result = response.data;

                        this.reponseData = response.data;
                       
                    });


            } else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication1")) {
            let encryptedText = this.$cookies.get("login_authentication1");
            const decryptedText = this.$CryptoJS.AES.decrypt(
                encryptedText,
                process.env.VUE_APP_ENCRYPTION_SECRET_KEY
            ).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/SystemAdmin");
                this.isAuthenticated = true;
                var productsURL1 = this.api_url + "/multiuser/get_org_list";
                this.$http
                    .post(productsURL1)
                    .then((response) => {
                        let result = response.data;

                        this.reponseData = response.data;
                       
                    });
            } else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else {
            this.$q.loading.hide();
            this.$router.push({
                name: "NotAuthenticated",
            });
            return;
        }


    },
    computed: {


        //  forgot_password_url() {
        //     var client_id = awsconfig.aws_user_pools_web_client_id;
        //     var justUrl = awsconfig.oauth.domain;
        //     var cognitoUrl =
        //       "https:" +
        //       justUrl +
        //       "/forgotPassword?response_type=code&client_id=" +
        //       client_id +
        //       "&redirect_uri=";
        //     var baseURL = window.location.origin + "/auth/signin/";
        //     //console.log(cognitoUrl);
        //     return cognitoUrl + baseURL;
        //   },


        error_name() {

            var regex = /^[a-zA-Z ]{3,30}$/;



            if (this.organisation['name'].length > 2) {
                this.is_name_valid = true;

                return '';


            }
            else if (this.organisation['name'].length < 3) {
                this.is_name_error = false;
                this.is_name_valid = false;
                return "";

            }



        },
        error_name1() {

            var regex = /^[a-zA-Z ]{3,30}$/;



            if (regex.test(this.user['name'])) {
                this.is_name1_valid = true;
                this.is_name1_error = false;

                return '';


            }
            else if (this.user['name'].length < 3) {
                this.is_name1_valid = false;
                this.is_name1_error = false;
                return "";

            }
            else {
                this.is_name1_valid = false;
                this.is_name1_error = true;
                return "";
            }



        },

        error_email1() {

            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;



            if (regex.test(this.user['email'])) {
                this.is_email1_valid = true;
                this.is_email1_error = false;

                return '';


            }
            else if (this.user['email'].length < 4) {
                this.is_email1_valid = false;
                this.is_email1_error = false;

                return '';

            }
            else {
                this.is_email1_valid = false;
                this.is_email1_error = true;
                return "";

            }



        },
        error_email() {

            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;



            if (regex.test(this.organisation['email'])) {
                this.is_email_valid = true;
                this.is_email_error = false;

                return '';


            }
            else if (this.organisation['email'].length < 4) {
                this.is_email_valid = false;
                this.is_email_error = false;

                return '';

            }
            else {
                this.is_email_valid = false;
                this.is_email_error = true;
                return "";

            }



        },
        error_company() {

            var regex = /^[a-zA-Z ]{3,30}$/;



            if (this.user['company'].length > 2) {
                this.is_company_valid = true;

                return '';


            }
            else if (this.user['company'].length < 3) {
                this.is_company_valid = false;
                return "";

            }



        },
        error_phone() {
            var regex = /[0-9]/;
            if (regex.test(this.organisation['phone']) && this.organisation['phone'].length == 10) {
                this.is_phone_valid = true;
                this.is_phone_error = false;
                return '';


            }
            else if (this.organisation['phone'].length < 10 && this.organisation['phone'].length > 0 || this.organisation['phone'].length > 10) {
                this.is_phone_valid = false;
                this.is_phone_error = true;
                return "";

            }
            else {
                this.is_phone_valid = false;
                this.is_phone_error = false;
                return "";

            }
        },
        error_phone1() {
            var regex = /[0-9]/;
            if (regex.test(this.user['phone']) && this.user['phone'].length == 10) {
                this.is_phone1_valid = true;
                this.is_phone1_error = false;
                return '';


            }
            else if (this.user['phone'].length < 10 && this.user['phone'].length > 0 || this.user['phone'].length > 10) {
                this.is_phone1_valid = false;
                this.is_phone1_error = true;
                return "";

            }
            else {
                this.is_phone1_valid = false;
                this.is_phone1_error = false;
                return "";
            }
        },
        error_address() {
            if (this.organisation['address'].length > 3) {
                this.is_address_valid = true;
                this.is_address_error = false;

                return '';
            }
            else if (this.organisation['address'].length == 0) {
                this.is_address_valid = false;
                this.is_address_error = false;
                return '';
            }
            else {
                this.is_address_valid = false;
                this.is_address_error = true;
                return '';
            }

        },
        error_gstin() {

            if (this.organisation['gstin'].length == 15) {
                this.is_gstin_valid = true;
                this.is_gstin_error = false;

                return '';
            }
            else if (this.organisation['gstin'].length == 0) {
                this.is_gstin_valid = false;
                this.is_gstin_error = false;

                return '';
            }
            else {
                this.is_gstin_valid = false;
                this.is_gstin_error = true;
                return '';
            }
        },


        error_password1() {

            var regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,15}$/;

            if (regex.test(this.user['password'])) {
                this.is_password1_valid = true;
                this.is_password1_error = false;

                return '';


            }
            else if (this.user['password'].length < 6) {
                this.is_password1_valid = false;
                this.is_password1_error = false;

                return '';

            }
            else {
                this.is_password1_valid = false;
                this.is_password1_error = true;
                return "";

            }



        },
        error_password() {

            var regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,15}$/;

            if (regex.test(this.organisation['password'])) {
                this.is_password_valid = true;
                this.is_password_error = false;

                return '';


            }
            else if (this.organisation['password'].length < 6) {
                this.is_password_valid = false;
                this.is_password_error = false;

                return '';

            }
            else {
                this.is_password_valid = false;
                this.is_password_error = true;
                return "";

            }



        },
        error_password_confirm() {
            if (this.organisation['password'] == this.organisation['password1'] && this.organisation['password'].length > 0) {
                this.is_passwordconfirm_valid = true;
                this.is_passwordconfirm_error = false;


            }
            else if (this.organisation['password'].length == 0) {
                this.is_passwordconfirm_valid = false;
                this.is_passwordconfirm_error = false;


            }
            else {
                this.is_passwordconfirm_valid = false;
                this.is_passwordconfirm_error = true;
            }

        },
        error_password_confirm1() {
            if (this.user['password'] == this.user['password1'] && this.user['password'].length > 0) {
                this.is_passwordconfirm1_valid = true;
                this.is_passwordconfirm1_error = false;


            }
            else if (this.user['password'].length == 0) {
                this.is_passwordconfirm1_valid = false;
                this.is_passwordconfirm1_error = false;


            }
            else {
                this.is_passwordconfirm1_valid = false;
                this.is_passwordconfirm1_error = true;
            }

        },

    },
    methods: {
        get_role(details) {
            this.orgRole = details;
        },
        get_org_id(details) {
            this.orgID = details;

        },
        accountData() {
            if (this.accountHandler == 'User') {
                return [
                    {


                        role: this.orgRole,
                        email: this.user["email"],
                        phone: this.user["phone"],
                        org_id: this.orgID,



                    },
                ]
            }
            else if (this.accountHandler == 'Organisation') {
                return [
                    {

                        name: this.organisation['name'],
                        address: this.organisation["address"],
                        email: this.organisation["email"],
                        gstin: this.organisation["gstin"],
                        phone: this.organisation["phone"],

                    },
                ]
            }
        },
        dataBase() {
            if (this.accountHandler == 'Organisation') {
                //console.log(this.accountData())
                let postURL = this.api_url + `/multiuser/create_org`;

                this.$http.post(postURL, this.accountData())
                    .then((response) => {
                        //console.log(response.data);
                        this.$q.loading.hide();

                        if (response.data == 'success') {
                            this.$alert('Please verify your email id using the link sent to your respective mail id', "Your data has been submitted successfully!", "success");
                            this.organisation['name'] = '';
                            this.organisation["address"] = '';
                            this.organisation["email"] = '';
                            this.organisation["gstin"] = '';
                            this.organisation["password"] = '';
                            this.organisation["password1"] = '';
                            this.organisation["phone"] = '';
                        }
                        else {
                            this.$alert('Please try again', 'Sorry! Your Data is not saved', 'error');
                        }

                    });
            }
            else if (this.accountHandler == 'User') {
                //console.log(this.accountData())
                let postURL = this.api_url + `/multiuser/create_org`;

                this.$http.post(postURL, this.accountData())
                    .then((response) => {
                        this.$q.loading.hide();
                        if (response.data == 'success') {
                            this.$alert('Please verify your email id using the link sent to your respective mail id', "Your data has been submitted successfully!", "success");
                            this.orgRole = 'Select Role';

                            this.user["email"] = '';
                            this.user["phone"] = '';
                            this.user["password"] = '';
                            this.user["password1"] = '';
                            this.orgID = 'organisation ID';
                        }
                        else {
                            this.$alert('Please try again', 'Sorry! Your Data is not saved', 'error');
                        }

                    });

            }

        },
        async submit() {


            if (this.accountHandler == 'User') {
                if (this.orgRole != 'Select Role' && this.orgID != 'organisation ID' && this.orgID != ' ' &&  this.is_email1_valid == true && this.is_phone1_valid == true && this.is_password1_valid == true && this.is_passwordconfirm1_valid == true) {




                    let user_name = this.user['name'];
                    let email = this.user["email"];
                    let phone = this.user["phone"];
                    let company = this.user["company"];
                    let password = this.user['password'];
                    //console.log(this.details);
                    this.$q.loading.show({
                        message: 'Submitting your request, please wait..'

                    });

                    try {
                        const { user } = await Auth.signUp({
                            username: email,
                            password: password,

                            attributes: {
                                email: email,          // optional

                            }



                        });

                        this.dataBase();

                        //console.log(user);
                        return;
                    } catch (error) {
                        this.$q.loading.hide();
                        this.$alert('user already exists, please check your credentials and try again', 'Could not sign up', 'error');
                        //console.log('error signing up:', error);

                    }
                }
                else {
                    this.$alert('Please follow correct format for each column', 'Could not sign up', 'error');
                }
            }
            else if (this.accountHandler == 'Organisation') {
                if (this.is_name_valid == true && this.is_address_valid == true && this.is_gstin_valid == true && this.is_email_valid == true && this.is_password_valid == true && this.is_passwordconfirm_valid) {

                    let user_name = this.organisation["email"];
                    let address = this.organisation["address"];
                    let email = this.organisation["email"];
                    let gstin = this.organisation["gstin"];
                    let phone = this.organisation["phone"];
                    let password = this.organisation['password'];




                    //console.log(this.details);
                    this.$q.loading.show({
                        message: 'Submitting your request, please wait..'

                    });

                    try {
                        const { user } = await Auth.signUp({
                            username: email,
                            password: password,

                            attributes: {
                                email: email,          // optional

                            }



                        });

                        this.dataBase();

                        //console.log(user);
                        return;
                    } catch (error) {
                        this.$q.loading.hide();
                        this.$alert('user already exists, please check your credentials and try again', 'Could not sign up', 'error');
                        //console.log('error signing up:', error);

                    }
                }
                else {
                    this.$alert('Please follow correct format for each column', 'Could not sign up', 'error');
                }
            }





        }
    }


}
</script>
<style>
.whole {
    margin-top: 50px;
}

.title {
    justify-content: center;
    display: flex;
    font-weight: bold;
}

.input-field {
    position: relative;
    width: 87%;
    height: 50px;
    line-height: 50px;
    margin: 11px auto;
}

.label-1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    color: #aaa;
    transition: 0.2s all;
    cursor: text;
    padding: 0 40px;
    font-size: 15px;
}

.label-2 {
    position: absolute;
    top: 0;
    right: 0;
    left: auto;
    width: 3%;
    color: #aaa;
    transition: 0.2s all;
    cursor: text;
    padding: 0 40px;
    font-size: 15px;

}

.label-3 {
    position: absolute;
    top: 0;
    right: 0;
    left: auto;

    color: #aaa;
    transition: 0.2s all;
    cursor: text;
    padding: 0 15px;
    font-size: 15px;



}

.label-3 .valid-icons {
    margin-top: 15px;
    width: 22px;
    height: auto;


}

input {
    width: 100%;
    border: 0;
    outline: 0;
    padding: 0rem 40px;
    border-radius: 3px;
    box-shadow: none;
    color: #111;
    font-size: 13x;
    outline: none;
    border-bottom: 2px solid #EBF0F4;
}

input:invalid {
    outline: 0;

}

input:focus,
input:valid {
    background-color: #EBF0F4;
    outline: none;
    border-bottom: 2px solid rgb(16, 38, 137);
}

input:focus~.label-1,
input:valid~.label-1 {
    font-size: 11px;
    top: -17px;


    /* display: none; */



}

.input-field .icons {
    position: absolute;
    left: 0;
    top: 8px;
    padding: 9px 8px;
    color: #aaa;
    transition: 0.3s;
}

input:focus~.icons {
    color: #0F8FE3;
}

.login {
    width: 87%;
    margin: 10px auto;
    margin-top: 20px;
}

.login button {
    width: 100%;
    display: inline-block;
    border: none;
    background-color: #102689;
    color: white;
    padding: 0px 20px;
    border-radius: 8px;
    font-size: 16px;
}

.login button:hover {
    scale: 1.005;

    cursor: pointer;

}

.forgot-password span {
    color: #E70B89;

}

.google-login {

    text-align: center !important;

}

.google-login img {

    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 8px;


}

.google-login img:hover {

    scale: 1.005;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    cursor: pointer;


}
</style>
